module.exports = __webpack_public_path__ + "static/media/3DPPA9.d2f7f3fa.jpg";